const ModelType = {
  MODEL2D: "2d",
  MODEL3D: "3d",
};

export default ModelType;
